import { Component, AfterViewInit, Input, OnDestroy } from '@angular/core'
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { DetailsAndScoreResponse } from '../../../models/flip/details-scores-response'
import { interval, throttleTime } from 'rxjs'
import { CommonService } from '../../../services/common/common.service'

@Component({
  selector: 'app-flip-groups-graph',
  imports: [],
  templateUrl: './flip-groups-graph.component.html',
  styleUrl: './flip-groups-graph.component.scss',
})
export class FlipGroupsGraphComponent implements AfterViewInit, OnDestroy {
  @Input() detailsAndScore!: DetailsAndScoreResponse
  private chart: Chart

  constructor(public commonService: CommonService) {}

  ngAfterViewInit(): void {
    this.initChart()
  }

  initChart() {
    if (!this.detailsAndScore?.flipScores) {
      return
    }

    const labels = this.detailsAndScore.flipScores.map((s) => s.groupName)
    const data = this.detailsAndScore.flipScores.map(
      (s) => s.percentScoreRounded,
    )

    if (this.chart) {
      this.chart.destroy()
    }

    this.chart = new Chart('skillsBarChart', {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Progress',
            data: data,
            backgroundColor: data.map((v) => (v > 0 ? '#009999' : '#cccccc')),
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'y',
        animation: false,
        responsive: true,
        plugins: {
          datalabels: {
            color: '#fff',
            anchor: 'end',
            align: 'left',
            clamp: true,
            clip: true,
            font: {
              size: 10,
            },
            formatter: (value, context) => {
              const index = context.dataIndex
              const score = this.detailsAndScore.flipScores[index]
              return `${score.totalCount} (${score.percentScoreRounded}%)`
            },
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex
                const score = this.detailsAndScore.flipScores[index]
                return [
                  `Order Number: ${score.orderNumber}`,
                  `Group Name: ${score.groupName}`,
                  `Total Score: ${score.totalCount} (${score.percentScoreRounded}%)`,
                ]
              },
            },
          },
          legend: {
            display: false,
            labels: {
              font: {
                size: 10,
              },
            },
          },
        },
        scales: {
          x: {
            min: 0,
            max: 100,
            ticks: {
              callback: (v) => v + '%',
              font: {
                size: 10,
              },
            },
          },
          y: {
            beginAtZero: true,
            max: 100,
            ticks: {
              callback: function (value, index) {
                const label = this.getLabelForValue(value as number)
                return label.length > 20
                  ? label.substring(0, 15) + '...'
                  : label
              },
              font: {
                size: 10,
              },
            },
          },
        },
      },
    })
  }

  ngOnDestroy(): void {
    this.chart?.destroy()
  }
}
